import React from 'react'
import { SnackbarProvider as NotistackProvider, useSnackbar as useNotistack, VariantType } from 'notistack'

export const SnackbarProvider = ({ children }: { children: React.ReactNode }) => (
  <NotistackProvider
    maxSnack={3}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    autoHideDuration={3000}
  >
    {children}
  </NotistackProvider>
)

export const useSnackbar = () => useNotistack()
export type { VariantType }
